import React, { useContext, useState } from "react";
import { Grid, Typography, Button, Box, FormControlLabel, Checkbox, TextField, IconButton } from "@mui/material";
import { ThemeContext } from "../../../context/ThemeContext";
import { getCookies, removeCookies } from "../../../services/Cookies";
import { useDispatch } from "react-redux";
import { logout, setLoggedIn, setUserDetails, setDecimalPlaces } from '../../../store/Slices/userSlice'
import { useSelector } from "react-redux";
import QR from '../../../assets/qr.png'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { changePassword, LoginApi } from '../../../api/request/auth'
import CryptoJS from "crypto-js";
import toast from "react-hot-toast";
import { setCookies } from "../../../services/Cookies";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const UserName = ({companyData}) => {
    const [passwordDetails, setPasswordDetails] = useState({ oldPassword: "", newPassword: "", confirmPassword: "", });
    const [isChangePasswordVisible, setIsChangePasswordVisible] = useState(false);
    const [is2FAVisible, setIs2FAVisible] = useState(false);
    const { darkMode } = useContext(ThemeContext)
    const dispatch = useDispatch()
    const { userDetail } = useSelector((state) => state.user);
    const UserName = localStorage.getItem('username')
    const password = localStorage.getItem('password')
    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY
    const { loggedIn } = useSelector(state => state.user);
    const id = getCookies('clientId')
    const {t} = useTranslation()
    // const SECRET_KEY = 'VERTEXDEMO'
    // console.log(SECRET_KEY);

    const navigate = useNavigate();

    const handleLogout = async () => {
        removeCookies("username", { path: "/" });
        removeCookies("token", { path: "/" });
        removeCookies("clientId", { path: "/" });
        removeCookies('gmtOffset',{path:'/'})
        localStorage.removeItem(`visibleColumns_${id}`)
        localStorage.removeItem('accountID')
        dispatch(setLoggedIn(false));
        dispatch(logout());
        window.location.href = "/";
    };

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordDetails({ ...passwordDetails, [name]: value });
    };

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();

        if (passwordDetails.newPassword !== passwordDetails.confirmPassword) {
        toast.error("New password and confirm password do not match!");
            return;
        }

        const payload = {
            clientId: userDetail?.id,
            oldPassword: passwordDetails.oldPassword,
            newPassword: passwordDetails.newPassword,
            confirmPassword: passwordDetails.confirmPassword,
        };

        try {
            const response = await changePassword(payload);
            if (response?.status === 200) {
                toast.success("Password changed successfully!");
                setIsChangePasswordVisible(false);
            } else {
                toast.error("Failed to change password. Please try again.");
            }
        } catch (error) {
            console.error("Error changing password:", error);
            toast.error("An error occurred while changing the password.");
        }
    };


    const handleLoginSaved = async (e) => {
        e.preventDefault();

        const savedUsername = localStorage.getItem("username");
        const encryptedData = localStorage.getItem("password");

        if (!savedUsername || !encryptedData) {
            toast.error("No saved login credentials found.");
            return;
        }

        // console.log("Encrypted Data from LocalStorage:", encryptedData);

        try {
            const iv = CryptoJS.enc.Base64.parse(encryptedData.substr(0, 24));
            const encryptedPassword = encryptedData.substring(24);

            // console.log("Extracted IV:", iv.toString(CryptoJS.enc.Base64));
            // console.log("Extracted Encrypted Password:", encryptedPassword);

            const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
            // console.log("Decryption Key:", key);

            const bytes = CryptoJS.AES.decrypt(encryptedPassword, key, { iv: iv });
            const decryptedPassword = bytes.toString(CryptoJS.enc.Utf8);

            // console.log("Decrypted Password:", decryptedPassword);

            if (!decryptedPassword) {
                toast.error("Failed to decrypt saved password.");
                return;
            }

            const params = {
                login_type: "api",
                username: savedUsername,
                password: decryptedPassword,
            };

            const { data } = await LoginApi(params);

            if (data?.token) {
                toast.success("Login successful!");
                setCookies("username", savedUsername, { path: "/", secure: true, sameSite: "strict" });
                setCookies("token", data?.token, { path: "/", secure: true, sameSite: "strict" });
                setCookies("refreshToken", data?.refreshToken, { path: "/", secure: true, sameSite: "strict", });
                setCookies("clientId", data?.client.id, { path: "/", secure: true, sameSite: "strict" });
                setCookies("gmtOffset", data?.gmtOffset, { path: "/", secure: true, sameSite: "strict", });

                dispatch(setLoggedIn(true));
                dispatch(setUserDetails(data?.client));
                dispatch(setDecimalPlaces(data?.decimalPlacesForAmountFormatting));
                navigate("/dashboard");
            } else {
                toast.error("Login failed. Please check your credentials.");
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "An error occurred while logging in.";
            toast.error(errorMessage);
        }
    };

    const handleRemove = () => {
        localStorage.removeItem('username')
        localStorage.removeItem('password')
    }

    return (
        <form>
            {!isChangePasswordVisible && !is2FAVisible ? (
                <Grid container spacing={2} sx={{ padding: "15px" }}>
                    <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
                        <Grid item xs={12}>
                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                    <Typography variant="body1" sx={{ m: 0, color: darkMode ? "var(--lightText)" : "var(--black)" }}>{UserName}</Typography>
                                    <Typography variant="body1" sx={{ m: 0, color: darkMode ? "var(--lightText)" : "var(--black)" }}>{userDetail?.deposit}</Typography>
                                </Box>
                                <Typography variant="caption" sx={{ m: 0, color: darkMode ? "var(--lightText)" : "var(--black)" }} noWrap>{userDetail?.id || "N/A"} - {companyData.companyName} -Demo</Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}>{t('name')}</Typography></Grid>
                        <Grid item xs={8}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}>{UserName}</Typography></Grid>
                        <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}>{t('server')}</Typography></Grid>
                        <Grid item xs={8}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}>{companyData.companyName} - Demo</Typography></Grid>
                        <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}>{t('login')}</Typography></Grid>
                        <Grid item xs={8}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}> {userDetail?.id}</Typography></Grid>
                        <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}> {t('password')}</Typography></Grid>
                        <Grid item xs={4}><Typography variant="body2" sx={{ color: "green" }}> {password ? "Saved" : "Not Saved"}</Typography></Grid>
                        <Grid item xs={4}><Typography variant="body2" className="text-primary" onClick={() => setIsChangePasswordVisible(true)} sx={{ cursor: "pointer" }}>{t('changePassword')}</Typography></Grid>
                        <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}> 2FA/TOTP</Typography></Grid>
                        <Grid item xs={4}><Typography variant="body2" sx={{ color: "red" }}>Disabled</Typography></Grid>
                        <Grid item xs={4}><Typography variant="body2" className="text-primary" sx={{ cursor: "pointer" }} onClick={() => setIs2FAVisible(true)}>Enable 2FA/TOTP</Typography></Grid>
                    </Grid>

                    <Grid container sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                        <Grid item sx={{ display: 'flex', gap: 1 }}>
                            <FormControlLabel control={<Checkbox className="custom-checkbox" checked={!!password} />} label={t('savePassword')} sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.85rem" }, color: darkMode ? "var(--lightText)" : "var(--black)", }} />
                            <Button type="submit" onClick={handleLoginSaved} variant="contained" color="secondary" sx={{ border: "1px solid green", marginTop: "20px", color: "white", padding: "5px", pl: 2, pr: 2, textTransform: "none", }}>{t('connectButton')}</Button>
                            <Button onClick={loggedIn ? handleLogout : handleRemove} type="submit" variant="outlined" sx={{ border: "1px solid red", marginTop: "20px", color: "red", padding: "5px", pl: 2, pr: 2, textTransform: "none", }}>   {loggedIn ? `${t('logout')}` : `${t('remove')}`}</Button>
                        </Grid>
                    </Grid>
                </Grid>
            ) : null}
            {isChangePasswordVisible && (
                <Grid container spacing={2} sx={{ padding: "15px" }}>
                    <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
                        <Grid item xs={12}><Typography variant="body1" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('changePassword')}</Typography></Grid>
                    </Grid>
                    <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
                        <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}>{t('login')}</Typography></Grid>
                        <Grid item xs={5}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}> {userDetail?.id}</Typography></Grid>
                    </Grid>
                    <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
                        <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('currentPassword')}</Typography></Grid>
                        <Grid item xs={5}>
                            <TextField name="oldPassword" type="password" placeholder={t('currentPassword')} fullWidth size="small" required value={passwordDetails.oldPassword} onChange={handlePasswordChange} className="custom-textfield" />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
                        <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('newPassword')}</Typography></Grid>
                        <Grid item xs={5}>
                            <TextField type="password" placeholder={t('newPassword')} fullWidth size="small" required name="newPassword" value={passwordDetails.newPassword} onChange={handlePasswordChange} className="custom-textfield" />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
                        <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('confirmPassword')}</Typography></Grid>
                        <Grid item xs={5}>
                            <TextField name="confirmPassword" type="password" placeholder={t('confirmPassword')} fullWidth size="small" required value={passwordDetails.confirmPassword} onChange={handlePasswordChange} className="custom-textfield" />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                        <Button type="submit" variant="contained" color="secondary" onClick={handlePasswordSubmit} sx={{ border: "1px solid green", marginTop: "20px", color: "white", padding: "5px", pl: 2, pr: 2, textTransform: "none", }}>{t('changePassword')}</Button>
                        <Button variant="outlined" color="secondary" onClick={() => setIsChangePasswordVisible(false)} sx={{ border: "1px solid green", textTransform: "none", marginLeft: "10px", marginTop: "20px", padding: "5px", pl: 2, pr: 2 }} > {t('cancel')} </Button>
                    </Grid>
                </Grid>
            )}
            {is2FAVisible && (
                <Grid container spacing={2} sx={{ padding: "15px" }}>
                    <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "5px" }}>
                        <Grid item xs={12}><Typography variant="body1" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}>{t('enableforaccount')} {userDetail?.id}</Typography></Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="caption" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}>2FA {t('faText')}</Typography>
                        <Typography variant="caption" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}>{t('downloadText')}</Typography>
                    </Grid>

                    <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                        <Box sx={{ width: 108, height: 108 }}><img src={QR} alt="QR Code" width="100%" height="100%" /></Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="caption" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}> {t('backupCode')}: </Typography>
                        <Typography variant="caption" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}> j3tb fj4t bu53 nxry rqcl y5qb k4 </Typography>
                        <IconButton variant="outlined" color="secondary" sx={{ borderRadius: 0, textTransform: "none", marginLeft: "10px", padding: "1px", }}>
                            <ContentCopyIcon sx={{ fontSize: '15px' }} />
                        </IconButton>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="caption" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}>{t('toCheck')}</Typography>
                    </Grid>
                    <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "5px", padding: '15px', paddingBottom: 0 }}>
                        <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('otp')}</Typography></Grid>
                        <Grid item xs={5}><TextField type="password" placeholder={t('otp')} fullWidth size="small" required className="custom-textfield" /></Grid>
                    </Grid>

                    <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                        <Button variant="contained" color="secondary" sx={{ border: "1px solid green", color: "white", padding: "5px", pl: 2, pr: 2, textTransform: "none" }} onClick={handlePasswordSubmit}>{t('enable')}</Button>
                        <Button variant="outlined" color="secondary" sx={{ border: "1px solid green", textTransform: "none", marginLeft: "10px", padding: "5px", pl: 2, pr: 2 }} onClick={() => setIs2FAVisible(false)}>{t('cancel')}</Button>
                    </Grid>
                </Grid>
            )}
        </form>
    );
};

export default UserName;